import { Box, Typography } from "@mui/material";
import { format } from "date-fns";
import { formatSaldo } from "../utils/general";

type CumulativeBalanceSummaryProps = {
    worked: number;
    expected: number;
    priorBalance?: number;
    cutoffDate?: Date;
};

export const CumulativeBalanceSummary = ({ worked, expected, priorBalance = 0, cutoffDate }: CumulativeBalanceSummaryProps) => {
    const saldo = priorBalance + (worked - expected);
    const showPriorBalance = priorBalance !== 0;
    return (
        <Box>
            <Typography component="span" variant="body1">
                {formatSaldo(saldo)}
            </Typography>
            {cutoffDate && (
                <Typography variant="caption" display="block" color="text.secondary">
                    Saldo até {format(cutoffDate, "dd/MM/yyyy")}
                </Typography>
            )}
            {showPriorBalance && (
                <Typography variant="caption" display="block" color="text.secondary">
                    De anos anteriores: {formatSaldo(priorBalance)}
                </Typography>
            )}
        </Box>
    );
};
